import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/scss/components/industrial/industrial-button.module.scss';
import cn from 'classnames';
import { supSub } from '../../services/util';

const IndustrialButton = ({ 
  text, 
  url, 
  variant = 'primary', 
  themeColor,
  className,
  onClick
}) => {
  if (!text) return null;

  const buttonClasses = cn(
    styles.button,
    {
      [styles.primary]: variant === 'primary',
      [styles.secondary]: variant === 'secondary',
      [styles.outline]: variant === 'outline'
    },
    className
  );

  const buttonStyle = {};
  
  // Apply theme color if provided
  if (themeColor) {
    if (variant === 'primary') {
      buttonStyle.backgroundColor = themeColor;
    } else if (variant === 'outline') {
      buttonStyle.borderColor = themeColor;
      buttonStyle.color = themeColor;
    }
    
    // Add custom property for hover effects in CSS
    buttonStyle['--theme-color'] = themeColor;
  }

  return (
    <a 
      href={url || '#'} 
      className={buttonClasses}
      style={buttonStyle}
      onClick={onClick}
    >
      <span dangerouslySetInnerHTML={{ __html: typeof text === 'string' ? supSub(text) : '' }} />
    </a>
  );
};

IndustrialButton.propTypes = {
  text: PropTypes.string.isRequired,
  url: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'outline']),
  themeColor: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default IndustrialButton;
